// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 100 101"
    {...props}
  >
    <path fill="#fff" d="M0 0H100V100H0z" transform="translate(0 .125)" />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.907}
      d="M18.1318 55.6016H10.6719V45.7796H18.1318M56.6719 45.7796H89.6177V55.6016H62.8613M17.0469 55.6013V80.125M83.25 55.6013V80.125M48.2419 67.0156H24.3359V41.5922C24.3359 37.4276 27.7112 34.0523 31.8758 34.0523H40.7021C44.8666 34.0523 48.2419 37.4276 48.2419 41.5922V59.0106M39.9297 67.0164V79.6133M32.7266 79.6133V75.9807H47.1303V79.6133M24.3359 59.707H41.1163M83.2488 36.4922H57.1406V20.1232H83.2488V36.4922ZM70.1953 36.4917V45.7773M48.2422 59.0106H54.8023V67.0156H48.2422M48.2422 52.8906H54.8023"
    />
  </svg>
);
const IconOfficeDeskOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconOfficeDeskOutline;
